import React from 'react';
import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import PropTypes from 'prop-types';

import pdfStyles from './styles';
import logo from '../../assets/images/TraxSmart.png';
import { DataBlock, TableData } from './InputData';

const Header = ({ reportName }) => (
  <View style={pdfStyles.headerWrapper}>
    <View style={pdfStyles.header}>
      <Image style={pdfStyles.logo} src={logo} alt="Logo" />
      <Text style={pdfStyles.date}>
        Generated on: {new Date().toLocaleString('en-IN')}
      </Text>
    </View>
    <Text style={pdfStyles.heading}>{reportName}</Text>
  </View>
);

const DataBlockWidget = ({ data }) => (
  <View style={pdfStyles.summary}>
    <Text style={pdfStyles.summaryHeading}>{data.heading}</Text>
    <View style={pdfStyles.divider} />
    <View style={pdfStyles.keyValueContainer}>
      {data.dataChunks?.map((el, index) => (
        <View key={index} style={pdfStyles.keyValueRow}>
          <Text style={pdfStyles.key}>{el.label} : </Text>
          <Text style={pdfStyles.value}> {el.value}</Text>
        </View>
      ))}
    </View>
  </View>
);

const Table = ({ headings, tableData }) => (
  <View style={pdfStyles.timeline}>
    <Text style={pdfStyles.timelineHeading}>Report Table</Text>
    <View style={pdfStyles.table}>
      <View style={pdfStyles.divider} />
      <View style={pdfStyles.tableRow}>
        {headings?.map((heading, index) => (
          <Text
            style={
              index === 0 ? pdfStyles.tableHeaderCell : pdfStyles.tableCell
            }
            key={index}
          >
            {heading}
          </Text>
        ))}
      </View>
      <View style={pdfStyles.divider} />
      {tableData?.map((row, idx) => (
        <View
          key={idx}
          wrap={false}
          style={
            idx % 2 === 0
              ? pdfStyles.tableRow
              : { ...pdfStyles.tableRow, backgroundColor: '#F5F5F5' }
          }
        >
          {row?.map((col, colIdx) => (
            <View
              key={colIdx}
              style={
                colIdx === 0 ? pdfStyles.tableHeaderCell : pdfStyles.tableCell
              }
            >
              <Text>{col}</Text>
            </View>
          ))}
        </View>
      ))}
    </View>
  </View>
);

const ReportExportPDF = ({ reportName, dataBlocks, tableData }) => {
  return (
    <Document>
      <Page size="A4" style={pdfStyles.page} orientation="landscape">
        <Header reportName={reportName} />
        {dataBlocks &&
          dataBlocks?.map((dataBlock) => <DataBlockWidget data={dataBlock} />)}
        {tableData && (
          <Table
            headings={tableData.headings}
            tableData={tableData.tableData}
          />
        )}
      </Page>
    </Document>
  );
};

ReportExportPDF.propTypes = {
  dataBlocks: PropTypes.arrayOf(PropTypes.instanceOf(DataBlock)),
  tableData: PropTypes.instanceOf(TableData),
  reportName: PropTypes.string
};

export default ReportExportPDF;
